import { faCalendarAlt, faLock, faPencilAlt, faUser, faUsers } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useEffect, useState } from 'react';
import { Col, Row, TabContent, TabPane } from 'reactstrap';
import Swal from 'sweetalert2';
import { informUserEvalLocked, smoothScrollTop } from '../../../../../Common.functions';
import CandidatesAlphabetical from '../CandidatesAlphabetical';
import Evaluation from '../Evaluation';
import Portfolio from '../Portfolio';
import Schedule from '../Schedule';
import Style from './EvaluateMobile.style';
import { isPrescreenInterviewDate } from 'Services/interviewDate';

const disabledColor = '#a8a8a8';
const iconSize = '2x';

const EvaluateMobile = ({
  adjacentDates,
  alarms,
  allDayRoom,
  candidateEvaluation,
  setCandidateEvaluationStatus,
  candidateEvaluationStatus,
  candidateInfo,
  candidateSortTypes,
  checkIfEvalsAreLocked,
  checkIfStatusNeedsChangingToModify,
  currentCandidateSortType,
  currentlyGettingEval,
  date,
  dataTypes,
  dContext,
  differences,
  disableJoinMeetingButton,
  DNRStatus,
  evalStatus,
  evaluationsLocked,
  firstBlockEarlyJoinInMinutes,
  filterCandidateInfo,
  firstBlockEarlyJoin,
  getCandidate,
  getCandidateDetails,
  getCandidateEvaluation,
  getCandidateStatus,
  getInfo,
  getPrescreen,
  handleDateChange,
  handleZoomClick,
  handleMeetingClick,
  headerHeight,
  heightOfHeader,
  incompleteCandidates,
  indexesWithDifferences,
  informUserMeetingIsStartingLocally,
  interviewHasPassed,
  interviewIsToday,
  isAdmin,
  isEmbedded,
  isLoading,
  isPrescreen,
  lockedStatuses,
  minutesToUpdate,
  pk_User,
  postRequest,
  getCandidateForDate,
  getNeedsAttention,
  reduxDate,
  requestVirtualMeetingEvaluator,
  requestZoomMeeting,
  schedule,
  scheduleError,
  Schedules4Eval__pkUUID_Schedule,
  Schedules4EvalJoinManualURL,
  selectedCandidateId,
  selectedCandidate,
  setAlarms,
  setCandidateEvaluation,
  setDate,
  setDisableJoinMeetingButton,
  setDNRStatus,
  selectedEvaluator,
  setEvalStatus,
  setLargePhoto,
  setSelectedTimeSlot,
  setSelectedCandidate,
  selectedTimeSlot,
  setParentActiveTab,
  setSchedules4Eval__pkUUID_Schedule,
  setSchedules4EvalJoinManualURL,
  setShowLargePhoto,
  setShowRed,
  setUserIdOnCurrentInterview,
  showRed,
  sortCandAscending,
  sortCandidates,
  timeoutDurationInMinutes,
  VirtualMeetingMode,
  userIdOnCurrentInterview,
  userInfo,
  mainRoomUrlDetails,
}) => {
  const [carouselIndex, setCarouselIndex] = useState(0);
  const [activeTab, setActiveTab] = useState('1');
  const [hasSchedule, setHasSchedule] = useState(null);
  const [selectedCandidateIdLocal, setSelectedCandidateIdLocal] = useState(null);
  const [disableEvaluation, setDisableEvaluation] = useState(true);
  const [error, setError] = useState(false);
  const [disableScreen, setDisableScreen] = useState(false);
  const [showSchedule, setShowSchedule] = useState(false);

  const [renderEval, setRenderEval] = useState(false);
  const [chosenCandidate, setChosenCandidate] = useState({ uniqueId: null, candidate: null });
  const [firstUserRecieved, setFirstUserRecieved] = useState(false);
  const stylething = { width: '100vw', display: 'none' };

  useEffect(() => {
    if (evalStatus === 'Complete') {
      getInfo();
      setActiveTab('3');
    }
  }, [evalStatus]);

  useEffect(() => {
    if (schedule && schedule.length > 0) {
      setHasSchedule(true);
    } else {
      setHasSchedule(false);
    }
  }, [schedule]);

  useEffect(() => {
    if (hasSchedule !== null) getDefaultTab();
  }, [date, hasSchedule]);

  useEffect(() => {
    if (selectedEvaluator && selectedEvaluator !== 'fetching') {
      if (selectedEvaluator.pk_Candidate !== selectedCandidateIdLocal) {
        setFirstUserRecieved(true);
        setActiveTab('3');
        smoothScrollTop();
        setSelectedCandidateIdLocal(selectedEvaluator.pk_Candidate);
      }
    }

    if ((!selectedEvaluator && disableEvaluation === false) || selectedEvaluator === 'fetching') {
      setDisableEvaluation(true);
    } else if (selectedEvaluator && selectedEvaluator !== 'fetching' && disableEvaluation === true) {
      setDisableEvaluation(false);
    }
  }, [selectedEvaluator]);

  useEffect(() => {
    if (selectedTimeSlot) {
      setActiveTab('3');
    }
  }, [selectedTimeSlot]);

  useEffect(() => {
    if (selectedCandidate && activeTab !== '3') {
      setActiveTab('3');
      smoothScrollTop();
    }
  }, [selectedCandidate]);

  useEffect(() => {
    if (pk_User) {
      setSelectedCandidate(null);
    }
  }, [pk_User]);

  const getDefaultTab = () => {
    if (isPrescreenInterviewDate(date)) {
      toggle('2');
      return;
    }
    if (hasSchedule) {
      toggle('1');
    } else {
      toggle('2');
    }
  };

  const changeEvalTab = () => {
    setRenderEval(false);
    const candidateToUse = isAdmin ? selectedEvaluator : selectedCandidate;

    return getCandidateEvaluation(candidateToUse.pk_Candidate, candidateToUse.pk_InterviewDate).then((res) => {
      setRenderEval(true);
      smoothScrollTop();

      if (!res.error) {
        setActiveTab('4');
        getInfo(true, true, false, currentCandidateSortType, sortCandAscending);
        return true;
      } else {
        setError(true);
        return false;
      }
    });
  };

  const changeToCandidateTab = () => {
    getInfo(true, true, false, currentCandidateSortType, sortCandAscending);
    setSelectedTimeSlot(null);
    setActiveTab('3');
  };

  const getEvalAndChangeTab = () => {
    if (checkIfEvalsAreLocked()) {
      informUserEvalLocked();
      return;
    }
    if (
      candidateEvaluationStatus &&
      candidateEvaluationStatus.Status &&
      candidateEvaluationStatus.Status.toUpperCase() === 'COMPLETE'
    ) {
      return Swal.fire({
        title: 'Do you want to modify this evaluation?',
        text: `Status will be set to "In progress."`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Modify',
      }).then((result) => {
        if (result.value === true) {
          getInfo(true, true, false, currentCandidateSortType, sortCandAscending);
          return changeEvalTab();
        }
      });
    } else {
      return changeEvalTab();
    }
  };

  const toggle = (tab) => {
    if (activeTab !== tab) setActiveTab(tab);
  };

  return (
    <div style={{ top: 0 }} className="mobile_wrapper">
      <div style={{ minHeight: 'calc(100vh - 280px)' }}>
        <TabContent activeTab={activeTab} style={{ width: '100%' }}>
          {schedule && (
            <TabPane tabId="1">
              <Schedule
                activeTab={activeTab}
                adjacentDates={adjacentDates}
                alarms={alarms}
                allDayRoom={allDayRoom}
                candidateInfo={candidateInfo}
                chosenCandidate={chosenCandidate}
                date={date}
                dContext={dContext}
                differences={differences}
                disableJoinMeetingButton={disableJoinMeetingButton}
                firstBlockEarlyJoin={firstBlockEarlyJoin}
                getCandidate={getCandidate}
                handleDateChange={handleDateChange}
                handleMeetingClick={handleMeetingClick}
                handleZoomClick={handleZoomClick}
                indexesWithDifferences={indexesWithDifferences}
                informUserMeetingIsStartingLocally={informUserMeetingIsStartingLocally}
                interviewIsToday={interviewIsToday}
                isMobile={true}
                isEmbedded={isEmbedded}
                mainRoomUrlDetails={mainRoomUrlDetails}
                postRequest={postRequest}
                reduxDate={reduxDate}
                requestVirtualMeetingEvaluator={requestVirtualMeetingEvaluator}
                requestZoomMeeting={requestZoomMeeting}
                schedule={schedule}
                Schedules4Eval__pkUUID_Schedule={Schedules4Eval__pkUUID_Schedule}
                Schedules4EvalJoinManualURL={Schedules4EvalJoinManualURL}
                selectedCandidate={selectedCandidate}
                selectedTimeSlot={selectedTimeSlot}
                setAlarms={setAlarms}
                setChosenCandidate={setChosenCandidate}
                setDate={setDate}
                setDisableJoinMeetingButton={setDisableJoinMeetingButton}
                setSchedules4Eval__pkUUID_Schedule={setSchedules4Eval__pkUUID_Schedule}
                setSchedules4EvalJoinManualURL={setSchedules4EvalJoinManualURL}
                setSelectedCandidate={setSelectedCandidate}
                setSelectedTimeSlot={setSelectedTimeSlot}
                setShowRed={setShowRed}
                setUserIdOnCurrentInterview={setUserIdOnCurrentInterview}
                showRed={showRed}
                userIdOnCurrentInterview={userIdOnCurrentInterview}
                virtualMeetingMode={VirtualMeetingMode}
              />
            </TabPane>
          )}
          <TabPane tabId="2">
            <Row>
              <Col md="12">
                <CandidatesAlphabetical
                  isPrescreen={isPrescreen}
                  candidateInfo={candidateInfo}
                  chosenCandidate={chosenCandidate}
                  disableJoinMeetingButton={disableJoinMeetingButton}
                  getCandidate={getCandidate}
                  handleZoomClick={handleZoomClick}
                  hasSchedule={hasSchedule}
                  interviewIsToday={interviewIsToday}
                  isAdmin={isAdmin}
                  isMobile={true}
                  postRequest={postRequest}
                  requestZoomMeeting={requestZoomMeeting}
                  Schedules4Eval__pkUUID_Schedule={Schedules4Eval__pkUUID_Schedule}
                  Schedules4EvalJoinManualURL={Schedules4EvalJoinManualURL}
                  selectedCandidate={selectedCandidate}
                  selectedCandidateId={selectedCandidateId}
                  selectedCandidateIdLocal={selectedCandidateIdLocal}
                  setChosenCandidate={setChosenCandidate}
                  setDisableJoinMeetingButton={setDisableJoinMeetingButton}
                  setSchedules4Eval__pkUUID_Schedule={setSchedules4Eval__pkUUID_Schedule}
                  setUserIdOnCurrentInterview={setUserIdOnCurrentInterview}
                  userIdOnCurrentInterview={userIdOnCurrentInterview}
                />
              </Col>
            </Row>
          </TabPane>
          <TabPane tabId="3">
            <Portfolio
              activeTab={activeTab}
              allDayRoom={allDayRoom}
              candidateEvaluationStatus={candidateEvaluationStatus}
              candidateInfo={candidateInfo}
              carouselIndex={carouselIndex}
              checkIfEvalsAreLocked={checkIfEvalsAreLocked}
              chosenCandidate={chosenCandidate}
              dataTypes={dataTypes}
              date={date}
              dContext={dContext}
              disableJoinMeetingButton={disableJoinMeetingButton}
              DNRStatus={DNRStatus}
              evaluationsLocked={evaluationsLocked}
              firstBlockEarlyJoin={firstBlockEarlyJoin}
              getCandidate={getCandidate}
              getEvalAndChangeTab={() => setActiveTab('3')}
              handleMeetingClick={handleMeetingClick}
              handleZoomClick={handleZoomClick}
              interviewIsToday={interviewIsToday}
              isEvaluate={!isPrescreenInterviewDate(date) && !isPrescreenInterviewDate(reduxDate)}
              lockedStatuses={lockedStatuses}
              isMobile={true}
              isAdmin={true}
              requestVirtualMeetingEvaluator={requestVirtualMeetingEvaluator}
              requestZoomMeeting={requestZoomMeeting}
              schedule={schedule || undefined} // if schedule us null pass in undefined so it gets it's default value in
              Schedules4Eval__pkUUID_Schedule={Schedules4Eval__pkUUID_Schedule}
              Schedules4EvalJoinManualURL={Schedules4EvalJoinManualURL}
              selectedCandidate={selectedCandidate}
              selectedTimeSlot={selectedTimeSlot}
              setCarouselIndex={setCarouselIndex}
              setChosenCandidate={setChosenCandidate}
              setDisableJoinMeetingButton={setDisableJoinMeetingButton}
              setDNRStatus={setDNRStatus}
              setLargePhoto={setLargePhoto}
              setSelectedCandidate={setSelectedCandidate}
              setShowLargePhoto={setShowLargePhoto}
              setShowSchedule={setShowSchedule}
              userIdOnCurrentInterview={userIdOnCurrentInterview}
              Status4SelectedDNR={
                candidateEvaluation && candidateEvaluation.Status ? candidateEvaluation.Status.EnableDoNotRank : false
              }
            />
          </TabPane>
          <TabPane tabId="4">
            {selectedEvaluator && (
              <div style={{ width: '100%', display: 'flex', justifyContent: 'space-evenly', alignItems: 'center' }}>
                <img style={{ height: '50px', width: 'auto' }} src={selectedEvaluator.CandidateSelectedPhotoSM} />
                <p style={{ padding: 0, margin: 0 }}>{selectedEvaluator.CandidateSelectedNameFull}</p>
              </div>
            )}
            {((!disableEvaluation && isAdmin) || !isAdmin) && renderEval && !evaluationsLocked && (
              <Evaluation
                activeTab={activeTab}
                candidateEvaluation={candidateEvaluation}
                candidateEvaluationStatus={candidateEvaluationStatus}
                candidateInfo={candidateInfo}
                checkIfStatusNeedsChangingToModify={checkIfStatusNeedsChangingToModify}
                currentlyGettingEval={currentlyGettingEval}
                date={date}
                DNRStatus={DNRStatus}
                evalStatus={evalStatus}
                evalTab="4"
                getCandidateEvaluation={getCandidateEvaluation}
                getCandidateStatus={getCandidateStatus}
                getInfo={getInfo}
                isAdmin={isAdmin}
                pk_User={pk_User}
                reduxDate={reduxDate}
                schedule={schedule}
                selectedCandidateId={selectedCandidateId}
                selectedEvaluator={selectedEvaluator}
                setCandidateEvaluation={setCandidateEvaluation}
                setCandidateEvaluationStatus={setCandidateEvaluationStatus}
                setDisableScreen={setDisableScreen}
                setDNRStatus={setDNRStatus}
                setEvalStatus={setEvalStatus}
                timeoutDurationInMinute={timeoutDurationInMinutes}
                typeOfEvent="touchstart"
                toggleToSchedule={() => {
                  if (schedule && schedule.length) {
                    setActiveTab('1');
                  } else {
                    setActiveTab('2');
                  }
                }}
                Status4SelectedDNR={
                  candidateEvaluation && candidateEvaluation.Status ? candidateEvaluation.Status.EnableDoNotRank : false
                }
              />
            )}
          </TabPane>
        </TabContent>
      </div>
      <Style.FixedNavigation>
        <Style.NavigationSub>
          <div>
            <div
              onClick={() => {
                if (hasSchedule && activeTab !== '1') {
                  setCarouselIndex(0);
                  smoothScrollTop();
                  getInfo(true, true, false, currentCandidateSortType, sortCandAscending);
                  setActiveTab('1');
                }
              }}
              style={{
                backgroundColor: hasSchedule ? '#084887' : disabledColor,
                // boxShadow: hasSchedule ? '0 0 10px 2px #00f' : 'none', // Glowing light blue effect
              }}
            >
              <FontAwesomeIcon style={{ left: '16px' }} size={iconSize} icon={faCalendarAlt} />
            </div>
            <p>Schedule</p>
          </div>
          <div>
            <div
              disabled={!selectedEvaluator}
              onClick={() => {
                if (activeTab !== '2' && (!isAdmin || (isAdmin && selectedEvaluator))) {
                  setCarouselIndex(1);
                  smoothScrollTop();
                  getInfo(true, true, false, currentCandidateSortType, sortCandAscending);

                  setActiveTab('2');
                }
              }}
              style={{ backgroundColor: '#D64933' }}
            >
              <FontAwesomeIcon style={{ left: '11px' }} size={iconSize} icon={faUsers} />
            </div>
            <p>Candidates</p>
          </div>
          <div>
            <div
              disabled={!selectedCandidate && !selectedTimeSlot}
              onClick={() => {
                if (activeTab !== '3' && selectedEvaluator && selectedTimeSlot) {
                  if (selectedTimeSlot) {
                    const { isFlexEvent, isScheduleBlock } = selectedTimeSlot;

                    if (isScheduleBlock) {
                      getCandidateEvaluation(selectedEvaluator.pk_Candidate, selectedEvaluator.pk_InterviewDate).then(
                        (res) => {
                          if (!res.error) {
                            setActiveTab('3');
                          } else {
                            setError(true);
                          }
                        },
                      );
                    } else {
                      setActiveTab('3');
                    }
                  } else {
                    setActiveTab('3');
                  }
                }
              }}
              style={{
                backgroundColor:
                  ((isAdmin && firstUserRecieved) || !isAdmin) &&
                  ((selectedCandidate !== 'fetching' && selectedCandidate) || selectedTimeSlot)
                    ? '#ADC698'
                    : disabledColor,
              }}
            >
              <FontAwesomeIcon style={{ left: '15px' }} size={iconSize} icon={faUser} />
            </div>
            <p>Details</p>
          </div>
          <div>
            <div
              disabled={disableEvaluation && isAdmin}
              onClick={() => {
                if (evaluationsLocked) {
                  informUserEvalLocked();
                  return;
                }

                if (disableEvaluation && isAdmin) return;

                if (selectedCandidate || selectedTimeSlot) {
                  getEvalAndChangeTab();
                }
              }}
              style={{
                backgroundColor:
                  ((isAdmin && firstUserRecieved) || !isAdmin) &&
                  selectedEvaluator !== 'fetching' &&
                  !evaluationsLocked &&
                  selectedCandidate !== 'fetching' &&
                  selectedCandidate
                    ? '#F7B538'
                    : disabledColor,
              }}
            >
              <FontAwesomeIcon
                style={{ left: evaluationsLocked ? '16px' : '14px' }}
                size={iconSize}
                icon={evaluationsLocked ? faLock : faPencilAlt}
              />
            </div>
            <p>Evaluation</p>
          </div>
        </Style.NavigationSub>
      </Style.FixedNavigation>
    </div>
  );
};

export default EvaluateMobile;
